export default "__VITE_ASSET__bcc18164__"